import React from 'react'

export default function Mail(props) {
    return (
        <svg 
            width="20"
            height="16" 
            viewBox="0 0 20 16" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path 
                d="M18.3327 3.00004C18.3327 2.08337 17.5827 1.33337 16.666 1.33337H3.33268C2.41602 1.33337 1.66602 2.08337 1.66602 3.00004M18.3327 3.00004V13C18.3327 13.9167 17.5827 14.6667 16.666 14.6667H3.33268C2.41602 14.6667 1.66602 13.9167 1.66602 13V3.00004M18.3327 3.00004L9.99935 8.83337L1.66602 3.00004" 
                stroke={props.color || "#667085"}
                strokeWidth="1.66667" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
            />
        </svg>
    )
}
